import React from 'react';
const WarningNotificationSVG = ({ className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <path
        d='M16.2975 13.5002L10.2975 3.00017C10.1667 2.76932 9.97695 2.57731 9.74769 2.44372C9.51843 2.31013 9.25783 2.23975 8.99249 2.23975C8.72715 2.23975 8.46656 2.31013 8.2373 2.44372C8.00804 2.57731 7.81832 2.76932 7.68749 3.00017L1.68749 13.5002C1.55525 13.7292 1.48591 13.9891 1.4865 14.2536C1.48709 14.518 1.55758 14.7776 1.69083 15.006C1.82408 15.2345 2.01535 15.4236 2.24526 15.5543C2.47517 15.685 2.73555 15.7525 2.99999 15.7502H15C15.2632 15.7499 15.5216 15.6804 15.7495 15.5486C15.9773 15.4169 16.1664 15.2275 16.2979 14.9995C16.4293 14.7715 16.4985 14.513 16.4985 14.2498C16.4984 13.9866 16.4291 13.7281 16.2975 13.5002Z'
        stroke='#FBA90A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 6.75V9.75'
        stroke='#FBA90A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 12.75H9.00667'
        stroke='#FBA90A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default WarningNotificationSVG;
